import React, { useEffect, useState } from "react";
import AudioPlayer from "../QuestionPage/AudioPlayer";
import ExamPanel from "./ExamPanel";

export default function MicrophoneCheckPage() {
  const [audioLink, setAudioLink] = useState("");

  useEffect(() => {
    const fetchSignedUrl = async () => {
      try {
        const res = await fetch("/ptedata/ptemedia/001_1585917752.mp3");
        const data = await res.json();
        setAudioLink(data.url);
      } catch (err) {
        console.error("Failed to fetch audio URL", err);
      }
    };

    fetchSignedUrl();
  }, []);

  return (
    <ExamPanel
      eyebrow="System check"
      title="Microphone Check"
      instructions={[
        "Make sure your headset is on and the microphone is positioned near your mouth.",
        'When you are ready, say "Testing, testing, one, two, three" into the microphone.',
        "Play the recording back. If your voice is not clear, raise your hand for assistance.",
      ]}
      media={
        <img
          className="h-28 w-36 object-contain sm:h-32 sm:w-44"
          src="/image/headphones.jpg"
          alt="Headset microphone"
        />
      }
      footer={
        <ul className="list-disc space-y-2 pl-5">
          <li>During the test, voice recordings will start automatically.</li>
          <li>You will not need manual Record, Playback, and Stop controls.</li>
        </ul>
      }
    >
      <div className="max-w-3xl rounded-md border border-slate-200 bg-slate-50 p-4">
        <AudioPlayer audioSrc={audioLink} />
      </div>
    </ExamPanel>
  );
}
